import React from 'react';
export default function EntMaskSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Leaf sprouts on top */}
      <path d="M14 8 C12 2 16 0 18 4 C17 2 14 3 14 8" fill="#66BB6A" />
      <path d="M26 8 C28 2 24 0 22 4 C23 2 26 3 26 8" fill="#4CAF50" />
      <path d="M20 6 C20 0 22 -1 22 3 C22 0 20 1 20 6" fill="#81C784" />

      {/* Main mask shape - bark texture */}
      <path d="M8 10 C6 10 4 16 4 24 C4 34 12 38 20 38 C28 38 36 34 36 24 C36 16 34 10 32 10 C28 8 12 8 8 10 Z" fill="#6D4C41" />
      {/* Inner bark layer */}
      <path d="M10 12 C8 12 6 18 6 24 C6 32 12 36 20 36 C28 36 34 32 34 24 C34 18 32 12 30 12 C26 10 14 10 10 12 Z" fill="#8D6E63" />

      {/* Bark grain lines */}
      <path d="M12 14 L12 34" stroke="#5D4037" strokeWidth="0.8" opacity="0.4" />
      <path d="M20 10 L20 36" stroke="#5D4037" strokeWidth="0.8" opacity="0.3" />
      <path d="M28 14 L28 34" stroke="#5D4037" strokeWidth="0.8" opacity="0.4" />

      {/* Eye hollows */}
      <ellipse cx="14" cy="20" rx="4" ry="3.5" fill="#3E2723" />
      <ellipse cx="26" cy="20" rx="4" ry="3.5" fill="#3E2723" />

      {/* Warm amber eyes */}
      <circle cx="14" cy="20" r="2" fill="#FFB74D" />
      <circle cx="26" cy="20" r="2" fill="#FFB74D" />
      <circle cx="14" cy="20" r="1" fill="#FF8F00" />
      <circle cx="26" cy="20" r="1" fill="#FF8F00" />
      <circle cx="13.5" cy="19.5" r="0.5" fill="white" opacity="0.5" />
      <circle cx="25.5" cy="19.5" r="0.5" fill="white" opacity="0.5" />

      {/* Nose - knot in wood */}
      <ellipse cx="20" cy="26" rx="2" ry="2.5" fill="#5D4037" />
      <ellipse cx="20" cy="26" rx="1.2" ry="1.5" fill="#4E342E" />

      {/* Mouth - bark split */}
      <path d="M14 32 C16 34 24 34 26 32" stroke="#4E342E" strokeWidth="1.5" fill="none" strokeLinecap="round" />

      {/* Small leaves on sides */}
      <path d="M4 18 C0 16 -1 20 3 20 C1 18 2 16 4 18" fill="#66BB6A" />
      <path d="M36 18 C40 16 41 20 37 20 C39 18 38 16 36 18" fill="#4CAF50" />

      {/* Moss patches */}
      <circle cx="10" cy="28" r="1.5" fill="#81C784" opacity="0.5" />
      <circle cx="30" cy="30" r="1.2" fill="#81C784" opacity="0.4" />
      <circle cx="16" cy="34" r="1" fill="#A5D6A7" opacity="0.4" />
    </svg>
  );
}
